import React, { useState, useEffect } from "react";
import axios from "axios";
import { api_url } from "../config/config";

const CouponManager = () => {
    const [coupons, setCoupons] = useState([]);
    const [newCoupon, setNewCoupon] = useState({
        coupon_code: "",
        amount: 0,
        eligibilityAmount: 0,
        from: "",
        to: "",
    });
    const [updateCoupon, setUpdateCoupon] = useState({
        coupon_code: "",
        amount: 0,
        eligibilityAmount: 0,
        from: "",
        to: "",
    });
    const [updateId, setUpdateId] = useState("");

    // Fetch coupons
    const fetchCoupons = async () => {
        try {
            const response = await axios.get(`${api_url}/coupons`);
            setCoupons(response.data.data);
        } catch (error) {
            alert("Failed to fetch coupons.");
        }
    };

    useEffect(() => {
        fetchCoupons();
    }, []);

    // Create coupon
    const handleCreateCoupon = async () => {
        try {
            await axios.post(`${api_url}/coupon`, {
                ...newCoupon,
                coupon_code: newCoupon.coupon_code.toUpperCase(),
                amount: parseFloat(newCoupon.amount),
                eligibilityAmount: Number(newCoupon.eligibilityAmount),
            });
            alert("Coupon created successfully!");
            setNewCoupon({
                coupon_code: "",
                amount: 0,
                eligibilityAmount: 0,
                from: "",
                to: "",
            }); // Clear form
            fetchCoupons();
        } catch (error) {
            alert("Failed to create coupon.");
        }
    };

    // Update coupon
    const handleUpdateCoupon = async () => {
        try {
            await axios.put(`${api_url}/coupon/${updateId}`, {
                ...updateCoupon,
                amount: parseFloat(updateCoupon.amount),
                eligibilityAmount: Number(updateCoupon.eligibilityAmount),
            });
            alert("Coupon updated successfully!");
            setUpdateId(""); // Clear update state
            setUpdateCoupon({
                coupon_code: "",
                amount: 0,
                eligibilityAmount: 0,
                from: "",
                to: "",
            });
            fetchCoupons();
        } catch (error) {
            alert("Failed to update coupon.");
        }
    };

    // Delete coupon
    const handleDeleteCoupon = async (id) => {
        try {
            await axios.delete(`${api_url}/coupon/${id}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('admin_token')
                    }
                }
            );
            alert("Coupon deleted successfully!");
            fetchCoupons();
        } catch (error) {
            alert("Failed to delete coupon.");
        }
    };

    const handlePrefillUpdate = (coupon) => {
        setUpdateId(coupon.coupon_id);
        setUpdateCoupon({
            coupon_code: coupon.coupon_code,
            amount: coupon.amount,
            eligibilityAmount: coupon.eligibilityAmount,
            from: coupon.from,
            to: coupon.to,
        });
    };

    return (
        <div className="max-w-4xl mx-auto p-6 space-y-10">
            <section className="p-4 bg-white shadow rounded border border-green-700">
                <h2 className="text-xl font-semibold mb-4">Create Coupon</h2>
                <div className="space-y-4">
                    <div>
                        <label className="block mb-1">Coupon Code</label>
                        <input
                            type="text"
                            placeholder="Coupon Code"
                            value={newCoupon.coupon_code}
                            onChange={(e) => setNewCoupon({ ...newCoupon, coupon_code: e.target.value })}
                            className="block w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block mb-1">Amount</label>
                        <input
                            type="number"
                            placeholder="Amount"
                            value={newCoupon.amount}
                            onChange={(e) => setNewCoupon({ ...newCoupon, amount: e.target.value })}
                            className="block w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block mb-1">Eligibility Amount</label>
                        <input
                            type="number"
                            placeholder="Eligibility Amount"
                            value={newCoupon.eligibilityAmount}
                            onChange={(e) =>
                                setNewCoupon({ ...newCoupon, eligibilityAmount: e.target.value })
                            }
                            className="block w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block mb-1">From Date</label>
                        <input
                            type="datetime-local"
                            value={newCoupon.from}
                            onChange={(e) => setNewCoupon({ ...newCoupon, from: e.target.value })}
                            className="block w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block mb-1">To Date</label>
                        <input
                            type="datetime-local"
                            value={newCoupon.to}
                            onChange={(e) => setNewCoupon({ ...newCoupon, to: e.target.value })}
                            className="block w-full p-2 border rounded"
                        />
                    </div>
                    <button
                        onClick={handleCreateCoupon}
                        className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
                    >
                        Create Coupon
                    </button>
                </div>
            </section>

            {/* Update Coupon Section */}
            {updateId && (
                <section className="p-4 bg-white shadow rounded border border-green-700">
                    <h2 className="text-xl font-semibold mb-4">Update Coupon</h2>
                    <div className="space-y-4">
                        <div>
                            <label className="block mb-1">Coupon Code</label>
                            <input
                                type="text"
                                placeholder="Coupon Code"
                                value={updateCoupon.coupon_code}
                                onChange={(e) =>
                                    setUpdateCoupon({ ...updateCoupon, coupon_code: e.target.value })
                                }
                                className="block w-full p-2 border rounded"
                            />
                        </div>
                        <div>
                            <label className="block mb-1">Amount</label>
                            <input
                                type="number"
                                placeholder="Amount"
                                value={updateCoupon.amount}
                                onChange={(e) =>
                                    setUpdateCoupon({ ...updateCoupon, amount: e.target.value })
                                }
                                className="block w-full p-2 border rounded"
                            />
                        </div>
                        <div>
                            <label className="block mb-1">Eligibility Amount</label>
                            <input
                                type="number"
                                placeholder="Eligibility Amount"
                                value={updateCoupon.eligibilityAmount}
                                onChange={(e) =>
                                    setUpdateCoupon({ ...updateCoupon, eligibilityAmount: e.target.value })
                                }
                                className="block w-full p-2 border rounded"
                            />
                        </div>
                        <div>
                            <label className="block mb-1">From Date</label>
                            <input
                                type="datetime-local"
                                value={updateCoupon.from}
                                onChange={(e) => setUpdateCoupon({ ...updateCoupon, from: e.target.value })}
                                className="block w-full p-2 border rounded"
                            />
                        </div>
                        <div>
                            <label className="block mb-1">To Date</label>
                            <input
                                type="datetime-local"
                                value={updateCoupon.to}
                                onChange={(e) => setUpdateCoupon({ ...updateCoupon, to: e.target.value })}
                                className="block w-full p-2 border rounded"
                            />
                        </div>
                        <button
                            onClick={handleUpdateCoupon}
                            className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600"
                        >
                            Update Coupon
                        </button>
                    </div>
                </section>
            )}

            {/* Coupon List */}
            <section className="p-4 bg-white shadow rounded ">
                <h2 className="text-xl font-semibold mb-4">All Coupons</h2>
                <ul>
                    {coupons.map((coupon) => (
                        <li key={coupon.coupon_id} className="flex justify-between items-center p-2 border-b">
                            <span>
                                {coupon.coupon_code} - {coupon.amount}
                            </span>
                            <div>
                                {/* <button
                                    onClick={() => handlePrefillUpdate(coupon)}
                                    className="bg-yellow-500 text-white py-1 px-2 rounded hover:bg-yellow-600 mr-2"
                                >
                                    Update
                                </button> */}
                                <button
                                    onClick={() => handleDeleteCoupon(coupon.coupon_id)}
                                    className="bg-red-500 text-white py-1 px-2 rounded hover:bg-red-600"
                                >
                                    Delete
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            </section>
        </div>
    );
};

export default CouponManager;
